import { call, put, takeLatest } from 'redux-saga/effects';
import * as passwordChangeForExchangeActions from 'redux/ducks/passwordChangeForExchange/passwordChangeForExchangeDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import memberAdminNoSessionApi from 'api/employee/memberAdminNoSessionApi';

export function* getAuthenticateFnm({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getAuthenticateFnm, payload);
    if (['V', 'R'].indexOf(response.emInofcStatsCd) !== -1) {
      yield put(alertActions.open({ message: ['MB_M_FINDPWD_FNM_ID_NOT_EM_STATUS'] }));
    } else {
      yield put(passwordChangeForExchangeActions.getAuthenticateFnmSuccess(response));
    }
  } catch (error) {
    yield put(passwordChangeForExchangeActions.setAuthenticateFnmFail(error));
  }
}

export function* getAuthenticateCallPhone({ payload }) {
  try {
    yield put(passwordChangeForExchangeActions.setRequestOtpState(false));
    yield call(memberAdminNoSessionApi.getAuthenticateCallPhone, payload);
  } catch (error) {
    yield put(passwordChangeForExchangeActions.setRequestOtpState(true));
  }
}

export function* getAuthenticateExternalMail({ payload }) {
  try {
    yield put(passwordChangeForExchangeActions.setRequestOtpState(false));
    yield call(memberAdminNoSessionApi.getAuthenticateExternalMail, payload);
  } catch (error) {
    yield put(passwordChangeForExchangeActions.setRequestOtpState(true));
  }
}

export function* getAuthenticateAuthNum({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getAuthenticateAuthNum, payload);
    yield put(passwordChangeForExchangeActions.getAuthenticateAuthNumSuccess(response));
    yield put(passwordChangeForExchangeActions.resetIncorrectOTPCount());
  } catch (error) {
    yield put(passwordChangeForExchangeActions.setAuthenticateAuthNumFail(error.errorCode));
  }
}

export function* modifyAuthenticatePassword({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.modifyAuthenticatePassword, payload);
    yield put(passwordChangeForExchangeActions.modifyAuthenticatePasswordSuccess(response));
  } catch (error) {
    yield put(passwordChangeForExchangeActions.modifyAuthenticatePasswordFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyPasswordWithCurrentPassword({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.modifyPasswordWithCurrentPassword, payload);
    yield put(passwordChangeForExchangeActions.modifyAuthenticatePasswordSuccess(response));
  } catch (error) {
    yield put(passwordChangeForExchangeActions.modifyAuthenticatePasswordFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* checkCurrentPassword({ payload }) {
  try {
    const { userId, pwd } = payload;
    const _payload = {
      userId,
      data: {
        pwd,
      },
    };
    const response = yield call(memberAdminNoSessionApi.checkCurrentPassword, _payload);
    if (response === true) {
      yield put(passwordChangeForExchangeActions.checkCurrentPasswordSuccess());
    } else {
      yield put(passwordChangeForExchangeActions.setCheckCurrentPasswordFail());
    }
  } catch (error) {
    yield put(passwordChangeForExchangeActions.setCheckCurrentPasswordFail());
  }
}

export default function* passwordChangeForExchangeSaga() {
  yield takeLatest(passwordChangeForExchangeActions.getAuthenticateFnm, getAuthenticateFnm);
  yield takeLatest(passwordChangeForExchangeActions.getAuthenticateCallPhone, getAuthenticateCallPhone);
  yield takeLatest(passwordChangeForExchangeActions.getAuthenticateExternalMail, getAuthenticateExternalMail);
  yield takeLatest(passwordChangeForExchangeActions.getAuthenticateAuthNum, getAuthenticateAuthNum);
  yield takeLatest(passwordChangeForExchangeActions.modifyAuthenticatePassword, modifyAuthenticatePassword);
  yield takeLatest(
    passwordChangeForExchangeActions.modifyPasswordWithCurrentPassword,
    modifyPasswordWithCurrentPassword,
  );
  yield takeLatest(passwordChangeForExchangeActions.checkCurrentPassword, checkCurrentPassword);
}
